import {
  Col,
  DatePicker,
  Divider,
  Form,
  Input,
  MenuProps,
  Row,
  Select,
  Space,
  Table,
} from 'antd';
import {
  CheckGray,
  CheckIcon,
  EyeIcon,
  FilterGoldIcon,
  FilterIcon,
  Remove,
  XFillIcon,
} from 'assets/svg';
import { MainLayout } from 'components';
import { Content } from 'antd/es/layout/layout';
import Button from 'components/Button';
import { useEffect, useState } from 'react';
import pageTitleStore from 'store/pageTitleStore';
import { ColumnsType } from 'antd/es/table';
import { HocChangePagination } from 'utils/HocChangePagination';
import { DEFAULT_PAGE_SIZE } from 'utils/constants';
import useQueryParam from 'hooks/useQueryPrams';
import { useMutation } from 'react-query';
import { useHistory } from 'react-router-dom';
import { useUser } from 'contexts/User';
import { useForm } from 'antd/es/form/Form';
import formatCurrencyVND from 'utils/formatCurrencyVND';
import { openNotificationWithIcon } from 'utils/notification';
import moment from 'moment';
import CapitalApi from 'apis/CapitalApi';
import AllocateApi from 'apis/AllocateApi';
import { DownloadOutlined } from '@ant-design/icons';
import * as XLSX from 'xlsx';
import formatNumber from 'utils/formatNumber';
import CartApi from 'apis/CartApi';
import { headerCapitalBranch } from 'constants/exportCapitalBranch';
import DropdownButton from 'components/DropdownButton';
import generateData from 'components/generateData';
import { headerDeclareCapitalBranch } from 'constants/exportDeclareCapitalBranch';
import { headerCabinet } from 'constants/exportCabinet';
import dayjs from 'dayjs';
import handleError401 from 'utils/handleError401';

type FixedType = 'left' | 'right' | boolean;

export default function ApproveOrderList() {
  const history = useHistory();
  const { user } = useUser();
  const [form] = useForm();
  const { RangePicker } = DatePicker;

  const setTitle = pageTitleStore((state) => state.setTitle);
  const setBreadcrumb = pageTitleStore((state) => state.setBreadcrumb);
  const [searchParam, setSearchParam] = useState<any>();
  const [isOpenFilter, setIsOpenFilter] = useState<boolean>(false);
  const [searchDateFrom, setSearchDateFrom] = useState<any>();
  const [dataApprove, setDataApprove] = useState<any>();
  const [dataExport, setDataExport] = useState<any>();
  const [nameFileExport, setNameFileExport] = useState<any>();
  const [exportAction, setExportAction] = useState<boolean>(false);
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [total, setTotal] = useState<any>();
  const queryParam = useQueryParam();
  const [listCapital, setListCapital] = useState<any>([]);
  const [formSubmitParams, setFormSubmitParams] = useState<any>({
    year: null,
  });
  const [defaultYear, setDefaultYear] = useState<number | null>(null);
  const page = parseInt(queryParam.get('page') + '') || 1;
  const page_size =
    parseInt(queryParam.get('page_size') + '') || DEFAULT_PAGE_SIZE;

  const capitalYearParam = formSubmitParams?.year ?? defaultYear;

  const params = {
    page: page,
    page_size: page_size,
    shop_code: user?.plantCode,
    ...(formSubmitParams && capitalYearParam != null
      ? {
          ...formSubmitParams,
          year: capitalYearParam,
        }
      : {}),
  };
  let btnExport = '';

  useEffect(() => {
    setTitle('Phê duyệt phân bổ');
    setBreadcrumb([
      {
        title: <a href="/">Phê duyệt</a>,
      },
      { title: <a href="">Phê duyệt phân bổ</a> },
    ]);

    const branchCodeRaw = user?.branch_code ?? user?.plantCode;
    const branchCode =
      branchCodeRaw !== undefined && branchCodeRaw !== null
        ? String(branchCodeRaw)
        : undefined;

    if (!branchCode) {
      const year = new Date().getFullYear();
      setDefaultYear(year);
      setFormSubmitParams((prev: any) => ({ ...prev, year }));
      return;
    }

    const fetchMaxCapitalYear = async () => {
      try {
        const response = await AllocateApi.getMaxCapitalYear(branchCode);
        const maxCapitalYear = response?.data?.max_capital_year;

        if (maxCapitalYear !== undefined && maxCapitalYear !== null) {
          const parsedYear = Number(maxCapitalYear);
          if (!Number.isNaN(parsedYear)) {
            setDefaultYear(parsedYear);
            setFormSubmitParams((prev: any) => ({
              ...prev,
              year: parsedYear,
            }));
            return;
          }
        }

        const year = new Date().getFullYear();
        setDefaultYear(year);
        setFormSubmitParams((prev: any) => ({ ...prev, year }));
      } catch (error: any) {
        if (error?.response?.status === 401) {
          handleError401();
        }
        const year = new Date().getFullYear();
        setDefaultYear(year);
        setFormSubmitParams((prev: any) => ({ ...prev, year }));
      }
    };

    fetchMaxCapitalYear();
  }, [user]);

  useEffect(() => {
    if (defaultYear !== null) {
      form.setFieldsValue({
        year: dayjs(String(defaultYear), 'YYYY'),
      });
    }
  }, [defaultYear, form]);

  useEffect(() => {
    if (!user || capitalYearParam == null) {
      return;
    }

    getCapitalShopApprove();
  }, [page, page_size, user, capitalYearParam]);

  useEffect(() => {
    if (exportAction == true) generateExcel(dataExport);
  }, [dataExport]);

  const columns: ColumnsType<any> = [
    {
      title: 'STT',
      dataIndex: 'id',
      width: 60,
      render: (text, record, index) => index + 1 + page_size * (page - 1),
    },
    {
      title: 'Mã cửa hàng',
      dataIndex: 'code',
      width: 160,
    },
    {
      title: 'Tên cửa hàng',
      width: 200,
      dataIndex: 'name',
    },
    {
      title: 'Năm phân bổ',
      width: 200,
      dataIndex: 'year',
    },
    {
      title: 'Trạng thái phê duyệt',
      width: 200,
      dataIndex: 'status',
      render: (_: any, record: any) => {
        return record.status == 0
          ? '_'
          : record.status == 1
          ? 'Đã gửi yêu cầu duyệt'
          : record.status == 2
          ? 'Đã duyệt'
          : record.status == 3
          ? 'Từ chối'
          : '_';
      },
    },
    ...(user?.role.includes('asm')
      ? [
          {
            title: 'Trạng thái phê duyệt của ASM',
            width: 200,
            dataIndex: 'asm_approve_status',
            render: (value: any, record: any) => {
              return value == undefined || value == null
                ? '-'
                : value == 0
                ? 'Chưa duyệt'
                : value == 1
                ? 'Đã duyệt'
                : 'Từ chối';
            },
          },
        ]
      : []),

    {
      title: 'Vốn phân bố tối thiểu (Min)',
      width: 250,
      dataIndex: 'von_phan_bo_min',
      render: (value: number) => {
        return <>{formatCurrencyVND(value)}</>;
      },
    },
    {
      title: 'Vốn phân bố tối đa (Max)',
      width: 250,
      dataIndex: 'von_phan_bo_max',
      render: (value: number) => {
        return <>{formatCurrencyVND(value)}</>;
      },
    },
    // {
    //   title: 'Vốn đăng ký Min',
    //   width: 200,
    //   dataIndex: 'von_dk_min',
    //   render: (value: number) => {
    //     return <>{formatCurrencyVND(value)}</>;
    //   },
    // },
    // {
    //   title: 'Vốn đăng ký Max',
    //   width: 200,
    //   dataIndex: 'von_dk_max',
    //   render: (value: number) => {
    //     return <>{formatCurrencyVND(value)}</>;
    //   },
    // },
    {
      title: 'Trạng thái phân bổ',
      width: 200,
      dataIndex: 'trang_thai_phan_bo',
    },
    {
      title: 'Mã công ty',
      width: 200,
      dataIndex: 'company_id',
    },
    {
      title: 'Tên công ty',
      dataIndex: 'company_desc',
      width: 120,
    },
    {
      title: 'Vùng miền',
      // dataIndex: 'shop',
      width: 250,
    },
    {
      title: 'Mã DC',
      dataIndex: 'dc_code',
      width: 100,
    },
    {
      title: 'Tỉnh thành',
      dataIndex: 'city',
      width: 250,
    },
    {
      title: 'Quận huyện',
      dataIndex: 'district',
      width: 250,
    },
    {
      title: 'Địa chỉ',
      dataIndex: 'address',
      width: 280,
    },
    {
      title: 'Số điện thoại',
      dataIndex: 'phone_number',
      width: 120,
    },
    {
      title: 'Tier cửa hàng',
      dataIndex: 'tier_name',
      width: 150,
    },
    {
      title: 'Mô hình cửa hàng',
      dataIndex: 'type_name',
      width: 180,
    },
    {
      title: 'Kênh cửa hàng',
      dataIndex: 'sale_group_name',
      width: 150,
    },
    {
      title: 'Ngày khai trương',
      dataIndex: 'createdAt',
      width: 150,
      render: (record: any) => {
        return moment(record?.createdAt).format('DD/MM/YYYY');
      },
    },
    {
      title: 'Cấp cửa hàng',
      dataIndex: 'class_name',
      width: 150,
    },
    {
      title: 'Ngày chỉnh sửa',
      dataIndex: 'updated_at',
      width: 150,
      render: (record: any) => {
        return moment(record?.updatedAt).format('DD/MM/YYYY');
      },
    },
    {
      title: 'Thao tác',
      fixed: 'right' as FixedType,
      width: 150,
      align: 'center',
      render: (_: any, record: any) => (
        <div className="flex justify-around items-center gap-4">
          {(user?.plantCode != 1000 &&
            user?.role.includes('cua_hang_truong') && (
              <div>
                <EyeIcon
                  onClick={() => {
                    history.push(`/approve-detail`, {
                      record: record,
                      year: record.year,
                    });
                  }}
                />
              </div>
            )) ||
            (!user?.role.includes('cua_hang_truong') &&
              user?.plantCode != 1000 && (
                <>
                  <div>
                    <EyeIcon
                      onClick={() => {
                        history.push(`/approve-detail`, {
                          record: record,
                          year: record.year,
                        });
                      }}
                    />
                  </div>
                  <div>
                    {(
                      user?.role.includes('asm')
                        ? record.asm_approve_status == 0
                        : record.status == 1
                    ) ? (
                      <CheckIcon
                        onClick={() => {
                          handleApprove(record, 'icon');
                        }}
                      />
                    ) : (
                      <CheckGray />
                    )}
                  </div>
                  {/* <div>
                    <Remove
                      onClick={() => {
                        handleRefuse(record, 'icon');
                      }}
                    />
                  </div> */}
                </>
              ))}
        </div>
      ),
    },
  ];

  const { mutate: getCapitalShopApprove } = useMutation(
    ['getCapitalShopApprove', params],
    () =>
      CapitalApi.getCapitalShopApprove(params)
        .then((res) => {
          setDataApprove(res.data);
          setTotal(res.total);
        })
        .catch((err) => {
          console.log(err);
        })
  );

  const { mutate: getAllCapitalShopApprove } = useMutation(
    CapitalApi.getCapitalShopApprove,
    {
      onSuccess: async (data: any) => {
        if (data.status === 'success') {
          const getData = [];
          if (btnExport == 'von') {
            setNameFileExport('Vốn');
            let listBranch = [];
            for (let i = 0; i < data?.data.length; i++) {
              let param = [];
              listBranch.push(data?.data[i].code);
              if (listBranch.length == 5 || i == data?.data.length - 1) {
                openNotificationWithIcon(
                  'warning',
                  `Đang tải các plant: ${listBranch}`
                );
                setIsLoading(true);
                param = await exportVon(listBranch);
                console.log('param: ', param);

                if (param.length < 1) {
                  openNotificationWithIcon(
                    'error',
                    `Các plant: ${listBranch} không có data`
                  );
                } else if (param.length > 0) {
                  for (let j = 0; j < param.length; j++) {
                    getData.push(param[j]);
                  }
                  openNotificationWithIcon(
                    'success',
                    `Tải các plant: ${listBranch} thành công`
                  );
                }
                listBranch = [];
              }
              if (i == data?.data.length - 1) setExportAction(true);
            }
          } else if (btnExport == 'khaiBaoVon') {
            setNameFileExport('Khai Báo Vốn');
            let listBranch = [];
            for (let i = 0; i < data?.data.length; i++) {
              let param = [];
              listBranch.push(data?.data[i].code);
              if (listBranch.length == 5 || i == data?.data.length - 1) {
                openNotificationWithIcon(
                  'warning',
                  `Đang tải plant: ${listBranch}`
                );
                param = await exportKhaiBaoVon(listBranch);
                if (param.length < 1) {
                  openNotificationWithIcon(
                    'error',
                    `Các plant: ${listBranch} không có data`
                  );
                } else if (param.length > 0) {
                  for (let j = 0; j < param.length; j++) {
                    getData.push(param[j]);
                  }
                  openNotificationWithIcon(
                    'success',
                    `Tải các plant: ${listBranch} thành công`
                  );
                }
                listBranch = [];
              }
              if (i == data?.data.length - 1) setExportAction(true);
            }
          } else if (btnExport == 'khaiBaoTu') {
            setNameFileExport('Khai Báo Tủ');
            let store_ids = [];
            for (let i = 0; i < data?.data.length; i++) {
              let param = [];
              store_ids.push(data?.data[i].code);
              if (store_ids.length == 5 || i == data?.data.length - 1) {
                openNotificationWithIcon(
                  'warning',
                  `Đang tải plant: ${store_ids}`
                );
                const listParam = {
                  capital_year: data?.data[i].capital_year,
                  status: data?.data[i].status,
                  store_ids: store_ids,
                };
                param = await exportKhaiBaoTu(listParam);
                if (param.length < 1) {
                  openNotificationWithIcon(
                    'error',
                    `Các plant: ${store_ids} không có data`
                  );
                } else if (param.length > 0) {
                  for (let j = 0; j < param.length; j++) {
                    getData.push(param[j]);
                  }
                  openNotificationWithIcon(
                    'success',
                    `Tải các plant: ${store_ids} thành công`
                  );
                }
                store_ids = [];
              }
              if (i == data?.data.length - 1) setExportAction(true);
            }
          }
          setDataExport(getData);
        } else {
          openNotificationWithIcon('error', 'Export thất bại');
        }
      },
      onError: (error) => {
        console.log('er: ', error);
        openNotificationWithIcon('error', 'Export thất bại');
      },
    }
  );

  const { mutate: refuseCapital } = useMutation(CapitalApi.putUpdateStatus, {
    onSuccess: (data: any) => {
      if (data.status == 'success') {
        openNotificationWithIcon('success', 'Từ chối thành công');
        getCapitalShopApprove();
        setListCapital([]);
        history.push(`/approve-order-list`);
      }
    },
    onError: () => {
      openNotificationWithIcon('error', 'Từ chối thất bại');
    },
  });

  const { mutate: approveCapital } = useMutation(CapitalApi.putUpdateStatus, {
    onSuccess: (data: any) => {
      if (data.status == 'success') {
        openNotificationWithIcon('success', 'Phê duyệt thành công');
        getCapitalShopApprove();
        setListCapital([]);
        history.push(`/approve-order-list`);
      }
    },
    onError: () => {
      openNotificationWithIcon('error', 'Phê duyệt thất bại');
    },
  });

  const onChangeInput = (
    e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    if (e.target.value === '') {
      setSearchParam({ ...searchParam, category_name_code: undefined });
    }
  };

  const onFinish = (values: any) => {
    const filteredData = Object.fromEntries(
      Object.entries(values).filter(([_, value]) => value !== undefined)
    );
    const stringifiedData: { [key: string]: any } = {};

    Object.keys(filteredData).forEach((key) => {
      if (key == 'range_date' && filteredData[key]) {
        const ranges: any = filteredData[key];
        stringifiedData['from_date'] = ranges[0].format('YYYY/MM/DD');
        stringifiedData['to_date'] = ranges[1].format('YYYY/MM/DD');
      } else if (key == 'year') {
        const date: any = filteredData[key];
        stringifiedData['year'] = date.$y;
      } else {
        stringifiedData[key] = String(filteredData[key]);
      }
    });
    setFormSubmitParams(stringifiedData);
    history.push(`/approve-order-list`);
  };

  const onCancel = () => {
    form.resetFields();
    const resetYear = defaultYear ?? new Date().getFullYear();
    form.setFieldsValue({
      year: dayjs(String(resetYear), 'YYYY'),
    });
    setFormSubmitParams({ year: resetYear });
    history.push(`/approve-order-list`);
  };

  const toggleFilter = () => {
    const next = !isOpenFilter;
    setIsOpenFilter(next);
    form.resetFields();
    if (!next) {
      return;
    }
    const year = defaultYear ?? new Date().getFullYear();
    form.setFieldsValue({
      year: dayjs(String(year), 'YYYY'),
    });
  };

  const onSelectChange = (selectedRows: any) => {
    setListCapital(selectedRows);
  };

  const rowSelection = {
    onChange: (selectedRowKeys: React.Key[], selectedRows: any[]) => {
      onSelectChange(selectedRows);
    },
    getCheckboxProps: (record: any) => ({
      name: record.name,
    }),
  };

  const handleRefuse = async (record: any, typeHandle: string) => {
    let list_capital = [];
    if (typeHandle == 'icon') {
      if (
        user?.role.includes('asm')
          ? record.asm_approve_status == 0
          : record.status == 1
      ) {
        list_capital.push(record.capital_id);
      } else {
        openNotificationWithIcon(
          'error',
          'Trạng thái cửa hàng phải là Chờ Duyệt'
        );
      }
    } else if (typeHandle == 'listItem') {
      if (record != undefined || record != null) {
        if (record.length > 0)
          for (let i = 0; i < record.length; i++) {
            if (record[i].status == 1) list_capital.push(record[i].capital_id);
            else {
              openNotificationWithIcon(
                'error',
                'Trạng thái cửa hàng ' + record[i].code + ' phải là Chờ Duyệt'
              );
              list_capital = [];
              break;
            }
          }
      }
    }
    if (list_capital.length > 0) {
      const params = {
        list_capital_id: list_capital,
        status: user?.role.includes('asm') ? 2 : 3,
        reject_reason: 'Không đạt yêu cầu',
      };
      refuseCapital(params);
    }
  };

  const handleApprove = async (record: any, typeHandle: string) => {
    let list_capital = [];
    if (typeHandle == 'icon') {
      if (
        user?.role.includes('asm')
          ? record.asm_approve_status == 0
          : record.status == 1
      ) {
        list_capital.push(record.capital_id);
      } else {
        openNotificationWithIcon(
          'error',
          'Trạng thái cửa hàng phải là Chờ Duyệt'
        );
      }
    } else if (typeHandle == 'listItem') {
      if (record != undefined || record != null) {
        if (record.length > 0)
          for (let i = 0; i < record.length; i++) {
            if (record[i].status == 1) list_capital.push(record[i].capital_id);
            else {
              openNotificationWithIcon(
                'error',
                'Trạng thái cửa hàng ' + record[i].code + ' phải là Chờ Duyệt'
              );
              list_capital = [];
              break;
            }
          }
      }
    }
    if (list_capital.length > 0) {
      const params = {
        list_capital_id: list_capital,
        status: user?.role.includes('asm') ? 1 : 2,
        reject_reason: '',
      };
      approveCapital(params);
    }
  };

  const itemsDroprown_exportBtn: MenuProps['items'] = [
    {
      label: 'Vốn',
      key: '1',
      onClick: () => {
        btnExport = 'von';
        handleExport('von');
      },
    },
    {
      label: 'Khai báo vốn',
      key: '2',
      onClick: () => {
        btnExport = 'khaiBaoVon';
        handleExport('khaiBaoVon');
      },
    },
    {
      label: 'Khai báo tủ',
      key: '3',
      onClick: () => {
        btnExport = 'khaiBaoTu';
        handleExport('khaiBaoTu');
      },
    },
  ];

  function generateExcel(dataExport: any) {
    const data = [];
    let headerFile: ColumnsType<any> = [];
    // create title
    if (nameFileExport == 'Vốn') {
      const header = headerCapitalBranch.map((column) => {
        return column.title;
      });
      headerFile = headerCapitalBranch;
      data.push(header);
    } else if (nameFileExport == 'Khai Báo Vốn') {
      const header = headerDeclareCapitalBranch.map((column) => {
        return column.title;
      });
      data.push(header);
      headerFile = headerDeclareCapitalBranch;
    } else if (nameFileExport == 'Khai Báo Tủ') {
      const header = headerCabinet.map((column) => {
        return column.title;
      });
      data.push(header);
      headerFile = headerCabinet;
    }

    const itemExport = Object.values(dataExport);

    // create data
    const rowData = generateData({
      data: data,
      dataExport: itemExport,
      header: headerFile,
      user: user,
    });

    const wb = XLSX.utils.book_new();
    const ws = XLSX.utils.aoa_to_sheet(rowData);
    XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');
    XLSX.writeFile(wb, `${nameFileExport}.xlsx`);
    setExportAction(false);
  }

  const exportVon = async (param: any) => {
    try {
      const response = await CartApi.exportVon(param);
      setIsLoading(false);
      return response.data; // Trả về dữ liệu từ API
    } catch (error) {
      setIsLoading(false);
      console.error('Export thất bại:', error);
      return [];
    }
  };

  const exportKhaiBaoTu = async (param: any) => {
    try {
      const response = await CartApi.exportKhaiBaoTu(param);
      setIsLoading(false);
      return response.data; // Trả về dữ liệu từ API
    } catch (error) {
      setIsLoading(false);
      console.error('Export thất bại', error);
      return [];
    }
  };

  const exportKhaiBaoVon = async (param: any) => {
    try {
      const response = await CartApi.exportKhaiBaoVon(param);
      setIsLoading(false);
      return response.data; // Trả về dữ liệu từ API
    } catch (error) {
      setIsLoading(false);
      console.error('Export thất bại', error);
      return [];
    }
  };

  const handleExport = async (btn: any) => {
    setDataExport([]);
    setExportAction(false);
    const param = {
      page: 1,
      page_size: total,
      shop_code: user?.plantCode,
      ...(formSubmitParams && formSubmitParams),
    };
    getAllCapitalShopApprove(param);
  };

  return (
    <MainLayout isLoading={isLoading}>
      <Row
        gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}
        justify="end"
        className="mb-1"
      >
        <Space>
          <Col className="flex justify-end">
            <DropdownButton
              bgColor="bg-primary-50"
              items={itemsDroprown_exportBtn}
              customClass="fix-border-radius mr-2"
            >
              <DownloadOutlined />
              Tải file excel
            </DropdownButton>
            <Button
              bgColor={'bg-white'}
              color={`${
                isOpenFilter ? 'text-primary-50' : 'text-secondary-50'
              }`}
              border={`${
                isOpenFilter ? 'border-primary-50' : 'border-secondary-50'
              }`}
              onClick={toggleFilter}
            >
              {isOpenFilter ? <FilterIcon /> : <FilterGoldIcon />}
              Lọc
            </Button>
          </Col>
        </Space>
      </Row>

      <Form
        layout="vertical"
        className={`items-center ${isOpenFilter ? '' : 'hidden'}`}
        autoComplete="off"
        form={form}
        onFinish={onFinish}
      >
        <Content>
          <Row gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}>
            <Col className="" span={6}>
              <Form.Item name="plant_code" label="Mã cửa hàng">
                <Input placeholder="Mã cửa hàng" className="" />
              </Form.Item>
            </Col>

            <Col className="" span={6}>
              <Form.Item name="text_search" label="Tên cửa hàng">
                <Input placeholder="Tên cửa hàng" className="" />
              </Form.Item>
            </Col>

            <Col className="" span={6}>
              <Form.Item label="Trạng thái phê duyệt" name="status">
                <Select
                  allowClear={true}
                  placeholder="Trạng thái phê duyệt"
                  size="small"
                >
                  <Select.Option value={0}>Chưa duyệt</Select.Option>
                  <Select.Option value={1}>
                    Đã gửi yêu cầu phê duyệt
                  </Select.Option>
                  <Select.Option value={2}>Đã duyệt</Select.Option>
                  <Select.Option value={3}>Từ chối</Select.Option>
                </Select>
              </Form.Item>
            </Col>
            <Col className="" span={6}>
              <Form.Item label="Năm phân bổ" name="year">
                <DatePicker
                  placeholder="yyyy"
                  className="ant-input"
                  format={'YYYY'}
                  picker="year"
                  allowClear={false}
                />
              </Form.Item>
            </Col>
          </Row>
          <Row gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }} justify="end">
            <Col className="flex justify-end" span={8}>
              <Space>
                <Button
                  bgColor={'bg-white'}
                  color={'text-primary-50'}
                  border={'border-primary-50'}
                  onClick={onCancel}
                >
                  Hủy
                </Button>
                <Button type="submit">Tìm kiếm</Button>
              </Space>
            </Col>
          </Row>
        </Content>
      </Form>

      <Content className="main-content mt-4">
        <Table
          rowKey={(record) => record.id}
          columns={columns}
          className="customTable"
          dataSource={dataApprove}
          scroll={{ x: 958 }}
          // loading={getCartsLoading}
          rowSelection={{
            type: 'checkbox',
            ...rowSelection,
          }}
          pagination={{
            className: 'flex items-center',
            current: page,
            pageSize: page_size,
            total: total,
            showSizeChanger: true,
            pageSizeOptions: ['10', '20', '50'],
            onChange: HocChangePagination(history),
          }}
        />
      </Content>
      {user?.plantCode != 1000 && !user?.role.includes('cua_hang_truong') && (
        <>
          <Divider
            style={{
              borderTop: '1px solid rgba(0, 0, 0, 0.2)',
              marginTop: '8px',
              marginBottom: '8px',
            }}
          />
          <Row gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }} justify="end">
            <Col
              className="flex justify-end"
              span={8}
              style={{ marginTop: '20px', marginRight: '2px' }}
            >
              <Button
                disabled={listCapital?.length == 0 ? true : false}
                bgColor={
                  listCapital?.length == 0 ? 'bg-gray-300' : 'bg-red-500'
                }
                onClick={() => {
                  handleRefuse(listCapital, 'listItem');
                }}
              >
                Từ chối
              </Button>
              <Button
                disabled={listCapital?.length == 0 ? true : false}
                bgColor={
                  listCapital?.length == 0 ? 'bg-gray-300' : 'bg-green-500'
                }
                onClick={() => {
                  handleApprove(listCapital, 'listItem');
                }}
              >
                Duyệt
              </Button>
            </Col>
          </Row>
        </>
      )}
    </MainLayout>
  );
}
